/** Must match api/constants/unitProposalStatuses.js values */
export const UNIT_PROPOSAL_STATUS_OPTIONS = [
  'Available',
  'Sold Out',
  'Booked',
  'Rented',
  'Coming Soon',
].map((value) => ({ label: value, value }));

export const DEFAULT_ALLOWED_UNIT_STATUSES = ['Available', 'Booked'];

export function statusesToMultiValue(selected) {
  const set = new Set(
    Array.isArray(selected)
      ? selected
      : DEFAULT_ALLOWED_UNIT_STATUSES
  );
  return UNIT_PROPOSAL_STATUS_OPTIONS.filter((o) => set.has(o.value));
}

export function multiValueToStatuses(multi) {
  if (!multi || !Array.isArray(multi)) return [];
  return multi.map((o) => o.value);
}
